/**
 * Item lookup view takes a collection
 *
 * Initialize it with an options object like this:
 *  { 
 *      title: 'Title at the top of the form',
 *      placeholder: 'Placeholder text for the form'
 *      collection: collection_you_want_to_look up
 *      action: function to run when the item is found
 *  }
 */
import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/item-lookup.hbs';

    export default Marionette.View.extend({
        template: Handlebars.compile(template),
        ui: {
            status: '.status',
            form: 'form',
            input: 'form input[name=item-lookup]',
            button: 'form button[type=submit]'
        },
        events: {
            'submit @ui.form': 'on_submit',
            'keyup @ui.input': 'on_submit'
        },
        initialize: function() {
            _.bindAll(this, 'fail', 'show_spinner', 'show_arrow');
        },
        onAttach: function() {
            this.ui.button.attr('disabled', true);
        },
        on_submit: function() {
            var coll = this.getOption('collection');
            var action = this.getOption('action');
            var fail = this.getOption('fail');
            var item_id = this.ui.input.val().trim();
            this.clear_status();
            
            if (this.ui.input.val().trim().length > 1) {
                this.ui.button.attr('disabled', false);
            } else {
                this.ui.button.attr('disabled', true);
            }

            if (item_id.length) {
                this.show_spinner();
                coll.search(item_id, this.getOption('request_data'))
                    .done(action.bind(this))
                    .fail(fail.bind(this))
                    .always(this.show_arrow)
                ;
            }
            return false;
        },
        clear_form: function() {
            this.ui.input.val(null);
        },
        reset_form: function(){
            this.clear_form();
            this.clear_status();
        },
        clear_status: function() {
            this.ui.status.addClass('hidden');
        },
        fail: function() {
            this.ui.status.removeClass('hidden');
        },
        // Change the button icon to a pulsing spinner icon
        show_spinner: function() {
            var icon = $(this.ui.button).find('i');
            if ( icon.attr('class') != 'fa fa-spinner fa-pulse' ) {
                this.old_button_icon_class = icon.attr('class');
            }
            icon.attr('class', 'fa fa-spinner fa-pulse');
        },
        // Change the button to its original icon.
        // Call this only after calling show_spinner because that's the
        // only way we preserve old_button_class
        show_arrow: function() {
            var icon = $(this.ui.button).find('i');
            icon.attr('class', this.old_button_icon_class);
        },
        onRender: function() {
            this.clear_status();
        },
        templateContext: function() {
            return {
                title: this.getOption('title'),
                placeholder: this.getOption('placeholder'),
                autocomplete: this.getOption('autocomplete')
            };
        }
    });
    

